module.exports = __webpack_public_path__ + "static/media/1001480TL.9e96a9fc.jpg";